import { useContextSelector } from 'use-context-selector';
import { AuthenticationContext } from "contexts/Authentication";

export const useAuth = () => {
  return {
    signIn: useContextSelector(AuthenticationContext, (c) => c.signIn),
    logout: useContextSelector(AuthenticationContext, (c) => c.logout),
    initializeAuth: useContextSelector(AuthenticationContext, (c) => c.initializeAuth)
  }
}

export const useIsAuthenticated = () => {
  return useContextSelector(AuthenticationContext, (c) => c.isAuthenticated)
};

export const useUser = () => {
  return {
    user: useContextSelector(AuthenticationContext, (c) => c.user)
  }
};
export const useUserId = () => {
  return useContextSelector(AuthenticationContext, (c) => c.userId)
};

export const useIsAdmin = () => {
  return useContextSelector(AuthenticationContext, (c) => c.isAdmin)
};
